import { OntologyField } from 'features/libra/ontology/ontologyFieldTypes'

type FieldValuesType = Record<string, unknown>

export const isFieldValueMissing = (value: unknown): boolean => {
  if (typeof value === 'string') {
    return value.length === 0
  }
  return value === undefined || value === null
}

export const getValueWithDefault = (
  value: unknown,
  fieldDefinition: OntologyField
): unknown =>
  isFieldValueMissing(value) && fieldDefinition.defaultValue !== undefined
    ? fieldDefinition.defaultValue
    : value

export const collectDefaultsForFields = (
  fieldValues: FieldValuesType,
  ontologyFields: Record<string, OntologyField>,
  fields: ReadonlyArray<string>
): Partial<FieldValuesType> => {
  return fields.reduce<Partial<FieldValuesType>>((acc, fieldId) => {
    const fieldDefinition = ontologyFields[fieldId]
    if (!fieldDefinition || fieldDefinition.defaultValue === undefined) {
      return acc
    }
    const currentValue = fieldValues?.[fieldId]
    if (isFieldValueMissing(currentValue)) {
      acc[fieldId] = fieldDefinition.defaultValue
    }
    return acc
  }, {})
}
